import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function minlengthValidationMessages(err: any, field: any) {
  return `Should have at least ${field.props.minLength} characters`;
}
export function fieldMatchValidator(control: AbstractControl) {
  const { password, passwordConfirm } = control.value;
  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }
  if (passwordConfirm === password) {
    return null;
  }
  return {
    fieldMatch: { message: "Passwords didn't match. Try Again" }
  };
}

export function EmailValidator(control: AbstractControl): ValidationErrors | null {
  const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return !control.value || emailPattern.test(control.value) ? null : { email: true };
}

export function EmailValidatorMessage(err: any, field: FormlyFieldConfig) {
  return `"${field?.formControl?.value}" is not a valid Email Address`;
}

export function PhoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  // Flexible pattern for country code with or without separators
  const phoneNumberPattern = /^\+\d{1,3}[\s]?(\d{3}[\s.-]?\d{3}[\s.-]?\d{3,4}|\d{9,10})$/;

  return phoneNumberPattern.test(control.value) ? null : { phone: true };
}

export function PhoneNumberValidatorMessage(err: any, field: FormlyFieldConfig) {
  return `Phone number has to be 10 digits long`;
}

export function PasswordComplexityValidator(
  control: AbstractControl
): ValidationErrors | null {
  const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,20}$/;
  return !control.value || passwordRegex.test(control.value)
    ? null
    : { passwordComplexity: true };
}

export function PasswordComplexityValidatorMessage() {
  return 'Must contain at least one uppercase letter, one lowercase letter, one number and one special character';
}
